/* eslint-disable */
import React, { Component } from "react";
import NavLogo from "../../assets/LogoFull.svg";
import NewHere from "../nav/NewHere.js";
import AdditionalPages from "../nav/AdditionalPages.js";

import $ from "jquery";
import LegacyWebsite from "../LegacyWebsite.js";

class FrontPageNavigation extends Component {
	//Stop the dropdown nav from reloading the page on mobile devices
	//Edited fix from Apropos scripts.js
	componentDidMount() {
		$("#topMain li.dropdown > a, #topMain li.dropdown-submenu > a").bind("click", function (e) {
			var addActiveClass = false;
			if ($(this).attr("href") == "#") {
				e.preventDefault();
			}

			e.stopPropagation();

			if ($(window).width() > 990) {
				return;
			}

			addActiveClass = $(this).parent().hasClass("resp-active");
			$("#topMain").find(".resp-active").removeClass("resp-active");
			$("#topMain").find(".active").removeClass("active");

			if (!addActiveClass) {
				$(this).parents("li").addClass("resp-active");
			}
		});
	}

	render() {
		return (
			<section>
				{/* TOP NAV */}
				<header id="topNav">
					<LegacyWebsite />
					<div className="container">
						{/*Mobile Menu Button */}
						<button className="btn btn-mobile" data-toggle="collapse" data-target=".nav-main-collapse">
							<i className="fa fa-bars"></i>
						</button>

						{/*Logo text or image */}
						<a className="logo scrollTo" href="#wrapper">
							<img src={NavLogo} height="55" alt="CRCK" />
						</a>

						{/* Top Nav */}
						<div className="navbar-collapse nav-main-collapse collapse pull-right">
							<nav className="nav-main mega-menu">
								<ul className="nav nav-pills nav-main scroll-menu" id="topMain">
									<li className="active">
										<a href="#wrapper">Home</a>
									</li>
									<li>
										<a href="#visit-us">Sunday Service</a>
									</li>
									<li>
										<a href="#about">About Us</a>
									</li>
									<li>
										<a href="#sermon">Sermons</a>
									</li>
									<li>
										<a href="#ministries">Ministries</a>
									</li>
									<li>
										<a href="#events">Events</a>
									</li>
									{/* <li>
										<a href="#team">Team</a>
									</li> */}

									{<NewHere />}
									{<AdditionalPages />}
								</ul>
							</nav>
						</div>
						{/* /Top Nav */}
					</div>
				</header>

				<span id="header_shadow"></span>
				{/* /TOP NAV */}
			</section>
		);
	}
}

export default FrontPageNavigation;
